const CURP_STATUSES = {
  approved: 'approved',
  automaticValidationFailed: 'automatic_validation_failed',
  pending: 'pending',
  rejected: 'rejected',
  waitingForValidation: 'waiting_for_validation'
};

export default CURP_STATUSES;
